import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import CssBaseline from '@mui/material/CssBaseline';
import {SnackbarProvider} from "notistack";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <GoogleOAuthProvider clientId="565678787345-ru0431f0n77ma1fret7ii5aicmf39mod.apps.googleusercontent.com">
        <CssBaseline />
        <div id={"root-div"}>
            <SnackbarProvider maxSnack={5} autoHideDuration={3000} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                <App />
            </SnackbarProvider>
        </div>
    </GoogleOAuthProvider>
);
